var exports = {
  "V": "x04b3a21e--b2aad4--subtitle",
};

module.exports = exports;
